/* REQ-013 · Pampas cart line notes (drawer + /cart). Ported from change/cart-notes (15.10) onto the live cart of 23.10.
   - The note is the visible line item property "הערות" (max 250), saved through /cart/change.js by key with the line's
     other properties merged in (Shopify replaces the whole properties object; SPIKE 15.10).
   - One pending save per line: a second save on the same line waits for the first and uses the key it returns
     (Codex G2 recheck). "מעבר לתשלום" waits for every pending save, then saves open editors one after another.
   - Event delegation on document, so it survives the theme rebuilding the cart markup (cart:build).
   The order note (cart.note) lives in assets/pampas-cart-order-note.js and is not touched here. */
(function () {
  if (window.pampasCartNotes) return;

  var KEY = 'הערות';
  var NEAR = 0.85;
  var UNDO_MS = 5000;
  var LIVE_LEFT = 20;

  function j(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(j); }
  function post(url, body, keepalive) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin', keepalive: !!keepalive,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(j);
  }
  function scopeOf(el) { return el.closest('#CartDrawer, #CartPageForm') || document; }
  function lineOf(el) { return el.closest('[data-pm-line]'); }
  function linesIn(scope) { return Array.prototype.slice.call(scope.querySelectorAll('[data-pm-line]')); }

  // ---------- saving: one pending save per line ----------
  var pending = {}; // line key -> promise of the save in flight

  function sameProps(a, b) {
    var ka = Object.keys(a || {}).sort(), kb = Object.keys(b || {}).sort();
    if (ka.length !== kb.length) return false;
    return ka.every(function (k, n) { return k === kb[n] && String(a[k]) === String(b[k]); });
  }
  // `qty`: the quantity the shopper sees on the line (Codex G3 adversarial #1 / recheck #2): never a snapshot read
  // before the save, so a +/− tapped just before or during the save is not reverted. The line's +/− are locked while
  // its note saves (is-pm-saving), so no new tap can race it.
  function changeNote(key, text, keepalive, qty) {
    return getCart().then(function (cart) {
      var index = -1, line = null;
      cart.items.forEach(function (i, n) { if (i.key === key) { line = i; index = n; } });
      if (!line) throw new Error('line-missing');
      var props = Object.assign({}, line.properties || {});
      if (text) props[KEY] = text;
      else { delete props[KEY]; if (!Object.keys(props).length) props[KEY] = ''; }
      var q = qty > 0 ? qty : line.quantity;
      return post('/cart/change.js', { id: key, quantity: q, properties: props }, keepalive).catch(function (err) {
        // the response may be lost although the change reached the store: recovery looks for exactly this line
        // (variant + every property), never "any line of the variant with this text" (Codex G3 adversarial-2 #1)
        err = err || new Error('save');
        // `pre`: how many OTHER lines already had exactly these properties before the save (adversarial-3 #1)
        var pre = cart.items.filter(function (i) { return i.key !== key && i.variant_id === line.variant_id && sameProps(i.properties, props); }).length;
        err.expected = { variant: line.variant_id, props: props, pre: pre };
        throw err;
      }).then(function (updated) {
        // the saved line by its contents (variant + properties): a save can merge it into an equal line, so the old
        // index may now hold another product (Codex G3 recheck #1); the index is only the fallback
        var items = (updated && updated.items) || [];
        var hit = items.filter(function (i) { return i.variant_id === line.variant_id && sameProps(i.properties, props); })[0] || items[index];
        return { cart: updated, index: index, key: hit ? hit.key : null };
      });
    });
  }
  // Chain onto a save already running for this line; the chained save uses the key the first one returned.
  function saveLineNote(key, text, keepalive, qty) {
    var before = pending[key];
    var run = (before ? before.catch(function () { return null; }) : Promise.resolve(null)).then(function (prev) {
      return changeNote(prev && prev.key ? prev.key : key, text, keepalive, qty);
    });
    pending[key] = run;
    var done = function () { if (pending[key] === run) delete pending[key]; };
    run.then(done, done);
    return run;
  }
  // Every saveLine in flight, as a promise of true (saved) / false (failed). Checkout waits for them and stops on a
  // failure (Codex G3 adversarial #2): an order must not go out without a note the shopper tried to save.
  var saving = [];
  function track(pr) {
    saving.push(pr);
    var drop = function () { saving = saving.filter(function (x) { return x !== pr; }); };
    pr.then(drop, drop);
    return pr;
  }
  function allSaving() { return Promise.all(saving.slice()); }

  // Ask the theme to rebuild the cart, then run `after(line)` on the line whose key is `key` once the new markup is in.
  // By key, not by cart index: a linked add-on takes an index in cart.items but renders as a hidden input, not a line
  // (Codex G3 review P2).
  function lineByKey(scope, key) {
    if (!key) return null;
    return linesIn(scope).filter(function (l) { return l.dataset.key === key; })[0] || null;
  }
  // Drafts open on other lines survive the rebuild (Codex G3 adversarial-2 #2): their text is put back in place, and
  // the line being typed in keeps the focus. `savedKey` is the line whose save triggered the rebuild (its old key).
  function draftsIn(scope, savedKey) {
    return linesIn(scope).filter(function (l) { return l.classList.contains('is-pm-editing') && l.dataset.key !== savedKey; }).map(function (l) {
      var i = l.querySelector('[data-pm-note-input]');
      return { key: l.dataset.key, text: i ? i.value : '', focused: document.activeElement === i };
    });
  }
  function restoreDrafts(scope, drafts) {
    var focusLine = null;
    drafts.forEach(function (d) {
      var l = lineByKey(scope, d.key);
      if (!l) return;
      openEditor(l, true, true);
      var i = l.querySelector('[data-pm-note-input]');
      i.value = d.text;
      drafts[d.key] = d.text;
      updateCount(i);
      if (d.focused) focusLine = l;
    });
    if (focusLine) { var fi = focusLine.querySelector('[data-pm-note-input]'); fi.focus(); fi.setSelectionRange(fi.value.length, fi.value.length); }
  }
  var reloadWhenFree = false;
  function maybeReload() {
    if (!reloadWhenFree) return;
    var page = document.getElementById('CartPageForm');
    if (page && !page.querySelector('[data-pm-line].is-pm-editing') && !saving.length) { reloadWhenFree = false; window.location.reload(); }
  }
  function rebuild(scope, key, after, savedKey) {
    var drafts = draftsIn(scope, savedKey);
    // /cart groups linked add-ons into their gift frame on the server; the theme's cart:build would swap in the
    // drawer markup there. Reload /cart instead when such add-ons are present (review fix T15, 15.10). A reload would
    // lose an open draft, so with a draft open the page is left as is until that draft is saved too.
    if (scope.id === 'CartPageForm' && scope.querySelector('[data-linked-addon-update]')) {
      if (!drafts.length) { window.location.reload(); return; }
      // reload deferred: bring the saved line's markup up to date in place (its new key everywhere the theme reads
      // it, the saved note shown), so the next edit or quantity change uses the right line (adversarial-7)
      var old = savedKey && lineByKey(scope, savedKey);
      if (old && key) {
        old.dataset.key = key;
        // the theme's quantity selector keeps the old key it read at start-up, so this line's quantity waits (locked)
        // until the reload, which runs as soon as no note is open on the page (adversarial-8)
        old.querySelectorAll('.js-qty__num, .js-qty__adjust').forEach(function (e) { if (e.tagName === 'INPUT') e.readOnly = true; else e.disabled = true; });
        old.classList.add('is-pm-stale');
        reloadWhenFree = true;
        old.querySelectorAll('[data-id="' + savedKey + '"]').forEach(function (e) { e.dataset.id = key; });
        old.querySelectorAll('[data-cart-remove-key="' + savedKey + '"]').forEach(function (e) { e.dataset.cartRemoveKey = key; });
        // the gift's "עריכה" link opens the dedication editor by line key (r2 adversarial-1)
        old.querySelectorAll('a.pm-gift__edit[href*="#pm-edit="]').forEach(function (e) { e.href = e.href.replace(/#pm-edit=.*$/, '#pm-edit=' + encodeURIComponent(key)); });
        var b = noteBody(old);
        if (b) {
          b.dataset.lineKey = key;
          var t = b.dataset.pmOriginal || '';
          var span = b.querySelector('[data-pm-note-text]');
          if (span) span.textContent = t;
          old.dataset.pmNoteState = t ? 'saved' : 'empty';
          closeEditor(old, false);
        }
        if (after) after(old, drafts.some(function (d) { return d.focused; }));
      }
      return;
    }
    // One cart:build at a time: the theme applies every markup response as it arrives, so two saves close together
    // could let an older response land last with stale notes and keys (train 30.10 adversarial). Each rebuild waits
    // for the previous one's markup to land and reads the open drafts only when its turn comes.
    queued++;
    rebuildQueue = rebuildQueue.then(function () {
      return new Promise(function (resolve) {
        var drafts = draftsIn(scope, savedKey);
        var products = scope.querySelector('[data-products]') || scope;
        var done = false, released = false;
        var finish = function () {
          if (done) return; done = true;
          // our own DOM changes here are not the theme's markup landing, so they must not release the queue
          mo.disconnect();
          var l = lineByKey(scope, key);
          var typing = drafts.some(function (d) { return d.focused; });
          if (l && after) after(l, typing);
          restoreDrafts(scope, drafts);
          if (!released) mo.observe(products, { childList: true, subtree: true });
        };
        // The queue moves on only when this rebuild's markup has landed, not on the 4s fallback: a slow response must
        // not arrive after the next rebuild's (recheck 30.10). The hard cap keeps a lost response from blocking saves.
        var release = function () {
          if (released) return; released = true; mo.disconnect(); queued--; resolve();
          if (!queued) verifyLater(scope);
        };
        // only new cart lines count as the markup landing; a note's character counter or other text changes do not
        // (train 31.10 adversarial)
        var linesAdded = function (records) {
          return records.some(function (r) {
            return Array.prototype.some.call(r.addedNodes, function (n) {
              return n.nodeType === 1 && (n.matches('[data-pm-line]') || n.querySelector('[data-pm-line]'));
            });
          });
        };
        var mo = new MutationObserver(function (records) {
          // a plain timer, not requestAnimationFrame: a tab in the background paints no frames, and the queue (and a
          // waiting checkout) must still move on
          if (linesAdded(records)) setTimeout(function () { finish(); release(); }, 0);
        });
        mo.observe(products, { childList: true, subtree: true });
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(finish, 4000);
        setTimeout(release, 20000);
      });
    });
  }
  var rebuildQueue = Promise.resolve(), queued = 0, healed = 0;
  function rebuildsDone() { return rebuildQueue.then(function () { return queued ? rebuildsDone() : null; }); }
  // Last line of defence against a markup response that still lands out of order: once no rebuild is queued, compare
  // the shown lines (keys and saved notes) with /cart.js and rebuild again if they differ (at most twice in a row).
  // Lines being edited are skipped; their text is the shopper's draft, not the saved note.
  function verifyLater(scope) {
    setTimeout(function () {
      if (queued || scope.id === 'CartPageForm' && scope.querySelector('[data-linked-addon-update]')) return;
      getCart().then(function (cart) {
        if (queued) return;
        var byKey = {};
        cart.items.forEach(function (i) { byKey[i.key] = (i.properties || {})[KEY] || ''; });
        var stale = linesIn(scope).some(function (l) {
          if (!(l.dataset.key in byKey)) return true;
          if (l.classList.contains('is-pm-editing') || l.classList.contains('is-pm-saving')) return false;
          var span = l.querySelector('[data-pm-note-text]');
          return !!span && span.textContent !== byKey[l.dataset.key];
        });
        if (!stale) { healed = 0; return; }
        if (healed >= 2) return;
        healed++;
        rebuild(scope, null, null, null);
      }).catch(function () {});
    }, 300);
  }

  // ---------- open drafts survive every cart rebuild (adversarial-4) ----------
  // The theme rebuilds the line markup on its own too (quantity change, add-on change), not only after a note save.
  // Every open editor's text is kept here by line key (a quantity change keeps the key, SPIKE 15.10) and put back
  // whenever the markup is replaced; a draft whose line is gone is dropped.
  var drafts = {};
  function keepDraft(line) {
    var i = line.querySelector('[data-pm-note-input]');
    if (i && line.classList.contains('is-pm-editing')) drafts[line.dataset.key] = i.value;
  }
  function dropDraft(key) { delete drafts[key]; }
  var restoring = false;
  function restoreAll() {
    if (restoring) return;
    restoring = true;
    Object.keys(drafts).forEach(function (key) {
      var found = false;
      ['#CartDrawer', '#CartPageForm'].forEach(function (sel) {
        var scope = document.querySelector(sel);
        var l = scope && lineByKey(scope, key);
        if (!l) return;
        found = true;
        if (l.classList.contains('is-pm-editing')) return;
        var text = drafts[key];
        openEditor(l, true, true);
        var i = l.querySelector('[data-pm-note-input]');
        i.value = text;
        drafts[key] = text;
        updateCount(i);
      });
      if (!found && !document.querySelector('[data-pm-line]')) return; // cart markup not built yet
      if (!found) dropDraft(key);
    });
    restoring = false;
  }
  function watchRebuilds() {
    ['#CartDrawer [data-products]', '#CartPageForm [data-products]'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el || el.__pmDrafts) return;
      el.__pmDrafts = true;
      var queued = false;
      new MutationObserver(function () {
        if (queued || !Object.keys(drafts).length) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; restoreAll(); });
      }).observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchRebuilds); else watchRebuilds();

  // ---------- counter ----------
  function updateCount(input) {
    var note = input.closest('[data-pm-note]');
    if (!note) return;
    var max = +input.dataset.pmMax || +input.maxLength;
    var len = input.value.length;
    var count = note.querySelector('[data-pm-count]');
    if (count) { count.textContent = len + '/' + max; count.classList.toggle('is-near', len >= Math.round(max * NEAR)); }
    var msg = note.querySelector('[data-pm-note-msg]');
    var left = max - len;
    if (left === LIVE_LEFT) msg.textContent = 'נשארו ' + LIVE_LEFT + ' תווים';
    else if (left === 0) msg.textContent = 'הגעתם למגבלה של ' + max + ' תווים';
  }

  // ---------- editor ----------
  function noteBody(line) { return line.querySelector('[data-pm-note]'); }
  function setExpanded(line, on) {
    line.querySelectorAll('[data-pm-note-open]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function openEditor(line, keepOthers, noFocus) {
    var body = noteBody(line);
    if (!body) return;
    if (!keepOthers) linesIn(scopeOf(line)).forEach(function (l) { if (l !== line && l.classList.contains('is-pm-editing') && !isDirty(l)) closeEditor(l, false); });
    var input = body.querySelector('[data-pm-note-input]');
    input.value = body.dataset.pmOriginal || '';
    body.querySelector('[data-pm-note-editor]').hidden = false;
    body.querySelector('.pm-note__saved').hidden = true;
    body.querySelector('[data-pm-note-msg]').textContent = '';
    line.classList.add('is-pm-editing');
    setExpanded(line, true);
    updateCount(input);
    keepDraft(line);
    if (noFocus) return;
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  }
  function closeEditor(line, focusOpener) {
    var body = noteBody(line);
    if (!body) return;
    var original = body.dataset.pmOriginal || '';
    body.querySelector('[data-pm-note-editor]').hidden = true;
    body.querySelector('.pm-note__saved').hidden = !original;
    body.querySelector('.pm-field').classList.remove('is-error');
    var btn = body.querySelector('[data-pm-note-save]');
    btn.textContent = 'שמירה';
    btn.disabled = false;
    line.classList.remove('is-pm-editing');
    setExpanded(line, false);
    dropDraft(line.dataset.key);
    setTimeout(maybeReload, 0);
    if (focusOpener) {
      var opener = line.querySelector(original ? '.pm-note-chip__open' : '.pm-note-add');
      if (opener) opener.focus();
    }
  }
  function isDirty(line) {
    var body = noteBody(line);
    if (!body || !line.classList.contains('is-pm-editing')) return false;
    return body.querySelector('[data-pm-note-input]').value.trim() !== (body.dataset.pmOriginal || '');
  }
  function showError(line) {
    var body = noteBody(line);
    body.querySelector('.pm-field').classList.add('is-error');
    body.querySelector('[data-pm-note-save]').textContent = 'לנסות שוב';
    body.querySelector('[data-pm-note-msg]').textContent = 'לא הצלחנו לשמור. הטקסט לא נמחק.';
  }
  function focusAfter(fresh, text) {
    var opener = fresh.querySelector(text ? '.pm-note-chip__open' : '.pm-note-add');
    if (opener) opener.focus();
  }
  function shownQty(line) {
    var q = line.querySelector('.js-qty__num') || line.querySelector('input[name="updates[]"]');
    var n = q ? parseInt(q.value, 10) : NaN;
    return n > 0 ? n : 0;
  }
  function saveLine(line, keepalive) {
    var body = noteBody(line);
    var key = body.dataset.lineKey;
    var text = body.querySelector('[data-pm-note-input]').value.trim();
    var previous = body.dataset.pmOriginal || '';
    var scope = scopeOf(line);
    var saveBtn = body.querySelector('[data-pm-note-save]');
    if (saveBtn.disabled && pending[key]) return pending[key].then(function () { return true; }, function () { return false; });
    saveBtn.disabled = true;
    // the line's quantity is frozen while its note saves: buttons disabled, the field read-only, so neither a tap nor
    // the keyboard can send a quantity change that races this save (adversarial-4/5)
    line.classList.add('is-pm-saving');
    // the note field itself is read-only while it saves, so text typed after "שמירה" cannot be lost when the line is
    // rebuilt from the saved text (r2 adversarial-2)
    var qtyEls = Array.prototype.slice.call(line.querySelectorAll('.js-qty__num, .js-qty__adjust, [data-pm-note-input]'));
    qtyEls.forEach(function (e) { if (e.tagName === 'INPUT' || e.tagName === 'TEXTAREA') e.readOnly = true; else e.disabled = true; });
    var unlock = function (ok) {
      line.classList.remove('is-pm-saving');
      qtyEls.forEach(function (e) { if (e.tagName === 'INPUT' || e.tagName === 'TEXTAREA') e.readOnly = false; else e.disabled = false; });
      return ok;
    };
    return track(saveLineNote(key, text, keepalive, shownQty(line)).then(function (res) {
      body.dataset.pmOriginal = text; // a tap on checkout before the rebuild must not see this editor as dirty
      dropDraft(key);
      rebuild(scope, res.key, function (fresh, typing) { if (!typing) focusAfter(fresh, text); if (!text && previous) offerUndo(fresh, previous); }, key);
      return true;
    }).catch(function (err) {
      // The save may have reached the store although the response was lost (the key then changed). Re-read the cart:
      // only a line with this variant and exactly the properties that were sent counts as saved. Otherwise, if the
      // old key is gone and a single line of the variant is left, adopt its key for the retry; show the error.
      var expected = err && err.expected;
      return getCart().then(function (cart) {
        // saved only when the target's old key is gone and the matching line did not exist before the save
        // (a line that already carried this note is another line, not this one; adversarial-3 #1)
        var still = cart.items.some(function (i) { return i.key === key; });
        var hit = expected && !still && expected.pre === 0 ? cart.items.filter(function (i) { return i.variant_id === expected.variant && sameProps(i.properties, expected.props); })[0] : null;
        if (hit) { body.dataset.pmOriginal = text; rebuild(scope, hit.key, function (fresh, typing) { if (!typing) focusAfter(fresh, text); }, key); return true; }
        var same = cart.items.filter(function (i) { return i.variant_id === +body.dataset.variantId; });
        if (!still && same.length === 1) body.dataset.lineKey = same[0].key;
        throw new Error('not-saved');
      }).catch(function () {
        saveBtn.disabled = false;
        // the editor may have been closed while the save was on its way: open it again with the text, so the error
        // and "לנסות שוב" are visible and checkout can point at it
        if (line.isConnected && !line.classList.contains('is-pm-editing')) {
          body.querySelector('[data-pm-note-editor]').hidden = false;
          body.querySelector('.pm-note__saved').hidden = true;
          body.querySelector('[data-pm-note-input]').value = text;
          line.classList.add('is-pm-editing');
          setExpanded(line, true);
        }
        keepDraft(line);
        showError(line);
        return false;
      });
    }).then(unlock, function () { return unlock(false); }));
  }
  function offerUndo(line, previous) {
    var body = noteBody(line);
    if (!body) return;
    var msg = body.querySelector('[data-pm-note-msg]');
    msg.textContent = '';
    var label = document.createElement('span');
    label.textContent = 'ההערה נמחקה';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pm-note__undo';
    btn.textContent = 'ביטול';
    msg.appendChild(label);
    msg.appendChild(document.createTextNode(' '));
    msg.appendChild(btn);
    var timer = setTimeout(function () { if (msg.isConnected) msg.textContent = ''; }, UNDO_MS);
    btn.addEventListener('click', function () {
      if (btn.disabled) return; // a second tap waits for the first (review minor 15.10)
      btn.disabled = true;
      clearTimeout(timer);
      var scope = scopeOf(line);
      // tracked like any save: checkout waits for it and stops if it fails (Codex G3 adversarial-2 #3)
      var undoKey = body.dataset.lineKey;
      // the same quantity lock as a save, until the restore finishes (r2 adversarial-5)
      var locked = Array.prototype.slice.call(line.querySelectorAll('.js-qty__num, .js-qty__adjust'));
      locked.forEach(function (e) { if (e.tagName === 'INPUT') e.readOnly = true; else e.disabled = true; });
      line.classList.add('is-pm-saving');
      var release = function (ok) {
        line.classList.remove('is-pm-saving');
        locked.forEach(function (e) { if (e.tagName === 'INPUT') e.readOnly = false; else e.disabled = false; });
        return ok;
      };
      track(saveLineNote(undoKey, previous, false, shownQty(line)).then(function (res) {
        rebuild(scope, res.key, function (fresh, typing) { if (!typing) focusAfter(fresh, previous); }, undoKey);
        return release(true);
      }, function () { msg.textContent = 'לא הצלחנו לשחזר את ההערה.'; return release(false); }));
    });
  }
  function clearLine(line, btn) {
    var body = noteBody(line);
    if (!body) return;
    var original = body.dataset.pmOriginal || '';
    if (!original) { closeEditor(line, true); return; } // × on a new, unsaved note = cancel
    if (btn.getAttribute('aria-busy') === 'true') return; // a double tap on × must not send a second save
    // a save already running on this line would swallow the clear (saveLine returns the pending save); the × is
    // locked while the line saves (pampas-cart-notes.css), and ignored here too (train 31.10 adversarial)
    if (line.classList.contains('is-pm-saving')) return;
    btn.setAttribute('aria-busy', 'true');
    body.querySelector('[data-pm-note-input]').value = '';
    line.classList.add('is-pm-editing');
    saveLine(line).then(function () { btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    var opener = t.closest('[data-pm-note-open]');
    if (opener && lineOf(opener)) { evt.preventDefault(); openEditor(lineOf(opener)); return; }
    var save = t.closest('[data-pm-note-save]');
    if (save && lineOf(save)) { evt.preventDefault(); saveLine(lineOf(save)); return; }
    var clear = t.closest('[data-pm-note-clear]');
    if (clear && lineOf(clear)) { evt.preventDefault(); clearLine(lineOf(clear), clear); }
  });
  document.addEventListener('input', function (evt) {
    if (!evt.target.matches('[data-pm-note-input]')) return;
    updateCount(evt.target);
    var l = lineOf(evt.target);
    if (l) keepDraft(l);
  });

  // Escape cancels the editor. The theme closes the drawer on Escape keyup: swallow the matching keyup.
  var escapeUsed = false;
  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && evt.target.matches('[data-pm-note-input]')) {
      evt.preventDefault();
      evt.stopPropagation();
      escapeUsed = true;
      closeEditor(lineOf(evt.target), true);
    }
  }, true);
  document.addEventListener('keyup', function (evt) {
    if (evt.key === 'Escape' && escapeUsed) { escapeUsed = false; evt.stopPropagation(); }
  }, true);

  // The bin on a plain line in the drawer is a link to /cart/change?…&quantity=0, which leaves the drawer for /cart.
  // Remove the line by Ajax and stay in the drawer (Ran 15.10). On failure, follow the link as before.
  // Gift lines keep their own remove handling (REQ-010/REQ-027).
  document.addEventListener('click', function (evt) {
    var a = evt.target.closest('#CartDrawer .pm-line .cart__remove-button');
    if (!a || !a.dataset.cartRemoveKey) return;
    evt.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    post('/cart/change.js', { id: a.dataset.cartRemoveKey, quantity: 0 }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function () { window.location.href = a.href; });
  });

  // ---------- checkout: wait for pending saves, then save open editors one after another ----------
  // An unticked terms click never gets here: the I-01 window-capture handler stops it first.
  // The same barrier guards a tap on "מעבר לתשלום" and a submit of the cart form towards checkout (Enter in a field,
  // a script calling submit; adversarial-3 #2). Express checkout buttons are held back by CSS while a note is open,
  // saving or failed (pampas-cart-notes.css), since they leave the page without either event.
  var flushing = false, redispatch = false;
  function needsFlush(scope) {
    return saving.length > 0 || queued > 0 || linesIn(scope).some(function (l) { return isDirty(l) || l.querySelector('.pm-field.is-error'); });
  }
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (redispatch || !form.matches || !form.matches('#CartDrawerForm, #CartPageForm')) return;
    if (evt.submitter && evt.submitter.name !== 'checkout') return; // "update cart" is not checkout
    var btn = form.querySelector('.cart__checkout');
    if (!btn) return;
    if (!flushing && !needsFlush(scopeOf(btn))) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    if (!flushing) btn.click(); // runs the click barrier below, then the theme's own checkout path
  }, true);
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('#CartDrawer .cart__checkout, #CartPageForm .cart__checkout');
    if (!btn || redispatch) return;
    if (flushing) { evt.preventDefault(); evt.stopImmediatePropagation(); return; } // extra taps wait
    var scope = scopeOf(btn);
    if (!needsFlush(scope)) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    flushing = true;
    // one pass: wait for every save in flight, then save the open editors one after another
    function pass() {
      return allSaving().then(function (results) {
        if (results.some(function (ok) { return !ok; })) return false;
        // a failed editor counts as dirty: its text is saved again here, in turn
        var todo = linesIn(scope).filter(function (l) { return isDirty(l) || l.querySelector('.pm-field.is-error'); });
        return todo.reduce(function (chain, l) {
          return chain.then(function (ok) { return ok ? saveLine(l, true) : false; });
        }, Promise.resolve(true)).then(function (ok) {
          // the forms submit the quantity inputs of the shown markup: leave only once every rebuild has landed
          // (train 31.10-2 adversarial)
          return ok ? rebuildsDone().then(function () { return true; }) : false;
        });
      });
    }
    // the shopper may open or edit another note while a pass runs: check again before leaving, until a fresh check
    // finds nothing open or saving (r2 adversarial-4; at most 5 passes, then stop and stay in the cart)
    function settle(n) {
      return pass().then(function (ok) {
        if (!ok) return false;
        if (!needsFlush(scope)) return true;
        return n > 1 ? settle(n - 1) : false;
      });
    }
    settle(5).then(function (ok) {
      if (ok && needsFlush(scope)) ok = false;
      // the rebuild replaces the checkout button too: click the one now in the cart, not the detached original
      if (ok) { setTimeout(function () { if (needsFlush(scope)) { flushing = false; return; } flushing = false; redispatch = true; (scope.querySelector('.cart__checkout') || btn).click(); redispatch = false; }, 50); return; }
      flushing = false;
      var bad = linesIn(scope).filter(function (l) { return l.querySelector('.pm-field.is-error'); })[0];
      if (bad) { bad.scrollIntoView({ block: 'center' }); var i = bad.querySelector('[data-pm-note-input]'); if (i) i.focus(); }
    });
  }, true);

  // Express checkout buttons (off today: settings.cart_additional_buttons) are made inert, for pointer and keyboard
  // alike, while a line note is open, saving or failed (adversarial-6). Re-checked on every relevant change.
  function syncExpress() {
    ['#CartDrawer', '#CartPageForm'].forEach(function (sel) {
      var scope = document.querySelector(sel);
      if (!scope) return;
      var hold = saving.length > 0 || linesIn(scope).some(function (l) { return l.classList.contains('is-pm-editing') || l.classList.contains('is-pm-saving'); });
      scope.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
        el.inert = hold;
        if (hold) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled');
      });
    });
  }
  ['click', 'input', 'focusin', 'keyup'].forEach(function (t) { document.addEventListener(t, function () { setTimeout(syncExpress, 0); }); });
  setInterval(function () { if (saving.length || document.querySelector('[data-pm-line].is-pm-editing')) syncExpress(); }, 500);
  document.addEventListener('cart:updated', function () { setTimeout(syncExpress, 0); });

  // ---------- keyboard in the drawer (phones) ----------
  // While a line note is being typed: hide the pinned checkout footer to free the space; keep the field in view.
  function drawer() { return document.getElementById('CartDrawer'); }
  function onViewport() {
    var a = document.activeElement, vv = window.visualViewport;
    if (!vv || !a || !a.matches('#CartDrawer [data-pm-note-input]')) return;
    var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    if (kb) a.scrollIntoView({ block: 'center' });
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onViewport);
    window.visualViewport.addEventListener('scroll', onViewport);
  }
  document.addEventListener('focusin', function (evt) {
    if (evt.target.matches('#CartDrawer [data-pm-note-input]') && drawer()) drawer().classList.add('is-pm-typing');
  });
  document.addEventListener('focusout', function (evt) {
    if (!evt.target.matches('#CartDrawer [data-pm-note-input]')) return;
    setTimeout(function () {
      var a = document.activeElement, d = drawer();
      if (d && (!a || !a.matches('#CartDrawer [data-pm-note-input]'))) d.classList.remove('is-pm-typing');
    }, 120);
  });

  window.pampasCartNotes = { saveLineNote: saveLineNote, rebuild: rebuild, isDirty: isDirty, saveLine: saveLine, linesIn: linesIn, pending: pending, saving: function () { return saving.length; } };
})();
